/* eslint-disable no-param-reassign */
import { updateProgressStepMV } from './utils/ProgressStepMV';
import { getSession, getUrlName } from './components/common/Helpers/index';
import history from './utils/history';

export const redirectToMV = (modelRootPath, hist) => {
  if (!hist) hist = history;

  let url = modelRootPath;
  if (!url.includes('sales/home/movers')) {
    url = `/sales/home/movers/${url}`;
  }
  return hist.push(url);
};

export const updateProcessOnBrowserActionMV = (location) => {
  const orderSubmitted = getSession('OrderSubmitted');
  const pageName = orderSubmitted !== 'Y' ? getUrlName(location.pathname) : 'confirmation';
  if (pageName) {
    updateProgressStepMV(pageName, true);
  }
};
